import styled from 'styled-components'

export const H2 = styled.h2`
  font-family: "Righteous";
    margin:0 auto;
     position: relative;
    font-size: 2.3rem;
    font-weight: 600;
    width: fit-content;
    filter: drop-shadow(rgb(136, 105, 180) 6px 4px 0px) drop-shadow(black 12px 4px 4px);
    color: #f3f3f3;
    border:1px solid #eee;
    padding:1rem;
    @media (max-width: 960px) {
    font-size: 1.4rem;
}
`;
export const Title = styled.h2`
  letter-spacing: 0.2rem;
  position: relative;
  width: fit-content;
  margin: 0 auto 5rem;
  padding: 1rem;
  z-index: 10;
  span {
    background: #000;
    z-index: 3;
    padding: 1rem 0.5rem;
  }
  &::before {
    background: linear-gradient(
      to right,
      #e700ff,
      #002bff,
      #ff00c4,
      var(--accent-color)
    );
    background-size: 300% 200%;
    position: absolute;
    content: "";
    top: -11%;
    left: 0%;
    width: 100%;
    height: 120%;
    font-size: 3rem;
    color: #0000;
    z-index: -1;
    opacity: 0.6;
    filter: blur(10px);
    animation: hero infinite ease 5s;
  }
`;